export const GET_LIST_OF_CITIES = 'GET_LIST_OF_CITIES';
export const CLEAR_CITIES_LIST = 'CLEAR_CITIES_LIST';

export const SET_LOCATION_START = 'SET_LOCATION_START';
export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_LOCATION_FAIL = 'SET_LOCATION_FAIL';

export const SEARCH_RESTAURANTS = 'SEARCH_RESTAURANTS';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';

export const GET_CUISINES_START = 'GET_CUISINES_START';
export const GET_CUISINES = 'GET_CUISINES';
export const GET_CUISINES_FAIL = 'GET_CUISINES_FAIL';
export const SET_SELECTED_CUISINES = 'SET_SELECTED_CUISINES';
export const CLEAR_SELECTED_CUISINES = 'CLEAR_SELECTED_CUISINES';

export const GET_RESTAURANTS_START = 'GET_RESTAURANTS_START';
export const GET_RESTAURANTS_SUCCESS = 'GET_RESTAURANTS_SUCCESS';
export const GET_RESTAURANTS_ERROR = 'GET_RESTAURANTS_ERROR';
export const CLEAR_RESTAURANTS = 'CLEAR_RESTAURANTS';

export const GET_RESTAURANT_START = 'GET_RESTAURANT_START';
export const GET_RESTAURANT_SUCCESS = 'GET_RESTAURANT_SUCCESS';
export const GET_RESTAURANT_ERROR = 'GET_RESTAURANT_ERROR';

export const GET_REVIEWS_START = 'GET_REVIEWS_START';
export const CLEAR_REVIEWS = 'CLEAR_REVIEWS';
export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS';
export const GET_REVIEWS_ERROR = 'GET_REVIEWS_ERROR';
